import FiltersDrawerCheckboxList from './FiltersDrawerCheckboxList'

export default FiltersDrawerCheckboxList
